<script setup lang="ts">
import DesktopHeader from './DesktopHeader.vue';
import MobileHeader from './MobileHeader.vue';
import type { PaletteColorProp } from '#imports';

interface IProps {
    hideMenu?: boolean;
    desktopColor?: 'white' | 'blue';
    menuColor?: 'white' | 'blue';
    showBack?: boolean;
    overlayHeader?: boolean;
    overlayHeaderInDesktop?: boolean;
    stickyInMobile?: boolean;
    mobileBackgroundColor?: PaletteColorProp | string;
    compact?: boolean;
    disableSwitchAccount?: boolean;
    mainAccountOnly?: boolean;
}
defineProps<IProps>();
const fixedBoxEnabled = ref(false);
const onscroll = () => {
    const topBar = (document as any).getElementsByClassName('wrapper');
    const rightSide = (document as any).getElementsByClassName(
        'full-width-right-side'
    );
    if (topBar?.[0] && rightSide?.[0]) {
        fixedBoxEnabled.value = document.documentElement.scrollTop > 0;
    }
};
onMounted(() => window.addEventListener('scroll', onscroll));
onUnmounted(() => window.removeEventListener('scroll', onscroll));
</script>

<template>
    <div class="wrapper">
        <header
            id="__header"
            class="header header-gradient"
            :class="{
                'header-overlay': overlayHeader,
                'header-overlay-in-desktop': overlayHeaderInDesktop,
            }"
        >
            <DesktopHeader
                :disable-switch-account
                :main-account-only
                class="desktop-only"
                :color="desktopColor"
                :compact
            />
            <MobileHeader
                :class="{ 'fixed-box': fixedBoxEnabled }"
                class="mobile-only"
                :show-back
                :sticky="stickyInMobile"
                :hide-menu
                :background-color="mobileBackgroundColor"
                :menu-color
            >
                <template #right-icon>
                    <slot name="mobile-right-icon" />
                </template>
                <template #left-icon>
                    <slot name="mobile-left-icon" />
                </template>
            </MobileHeader>
        </header>
    </div>
</template>

<style scoped lang="scss">
.wrapper {
    width: 100%;
}
.header {
    height: 70px;
    background-color: usePalette();
    display: flex;
    align-items: center;
    justify-content: space-between;
    @include desktop-only() {
        padding-inline: 8px;
    }
    @include desktop-only($app-container-max-width) {
        padding-inline: 75px;
    }
}

.header-overlay {
    position: absolute;
    z-index: 900;
    width: 100%;
    background: none;
}

@media (min-width: $app-desktop-min-width) {
    .header-overlay-in-desktop {
        position: absolute;
        z-index: 900;
        width: 100%;
        background: none;
    }
}

@media (max-width: $app-mobile-max-width) {
    .header {
        height: 64px;
        z-index: 1000000;
    }

    .fixed-box {
        position: fixed;
        top: 0;
        background: usePalette();
        z-index: 10000 !important;
        width: 100%;
        height: 62px !important;
    }
}
</style>
